"use client";
import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FeaturedSkeleton from "../../Skeleton/Featured";
import type { Model } from "@/lib/types";

type HomeModel = Pick<Model, "id" | "name" | "thumbnail">;

const Models = () => {
  const [featured] = useState<HomeModel[]>([
    {
      id: 1,
      name: "250ml Slim Can",
      thumbnail: "/models/a0eebc99-9c0b-4ef8-bb6d-6bb9bd380a11/preview.png",
    },
    {
      id: 2,
      name: "330 Standard Can",
      thumbnail: "/models//f47ac10b-58cc-4372-a567-0e02b2c3d479/preview.png",
    },
    {
      id: 3,
      name: "24 x 250 ml Tray Box",
      thumbnail: "/models/292b56f7-44b2-4962-a5ce-fc856c912842/preview.png",
    },
  ]);
  const [loading] = useState(false);

  // Responsive settings logic
  const settings = {
    dots: true,
    infinite: featured.length > 2,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    dotsClass: "slick-dots custom-dots-container",
    appendDots: (dots: React.ReactNode) => (
      <div style={{ bottom: "-45px" }}>
        <ul className="flex items-center justify-center gap-3"> {dots} </ul>
      </div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="relative bg-deepSlate dark:bg-darkmode py-20 overflow-hidden">
      {/* Container is constrained to max-w-5xl to make cards look smaller without narrowing them */}
      <div className="container mx-auto max-w-5xl px-4 relative">
        <div className="text-center mb-10">
          <p className="text-primary text-sm tracking-[0.3em] font-bold uppercase mb-2">
            Showcase
          </p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-black dark:text-white">
            Available Models
          </h2>
        </div>

        <Slider {...settings}>
          {loading
            ? Array.from({ length: 2 }).map((_, index) => (
                <div key={index} className="px-3">
                  <FeaturedSkeleton />
                </div>
              ))
            : featured.map((items) => (
                <div key={items.id} className="px-4 pb-10">
                  <div className="bg-white dark:bg-slate-900 rounded-[2rem] p-3 shadow-xl border border-gray-100 dark:border-slate-800">
                    {/* Fixed aspect ratio container (Square-ish) */}
                    <div className="relative w-full aspect-[4/3] overflow-hidden rounded-[1.5rem]">
                      <img
                        src={items.thumbnail}
                        alt={items.name}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                      />
                    </div>

                    <div className="p-5">
                      <h4 className="font-bold text-xl text-black dark:text-white truncate">
                        {items.name}
                      </h4>
                      <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">
                        Professional 3D Render
                      </p>
                    </div>
                  </div>
                </div>
              ))}
        </Slider>
      </div>
    </section>
  );
};

export default Models;
